<template>

<app-section>

    <app-filter>

        <app-input icon="date" :is-inline="true" type="date" placeholder="From" v-model="filter.from" />
        <app-input type="date" :is-inline="true" placeholder="To" v-model="filter.to" />

    </app-filter>

    <app-panel :tabs="domainTabs" :is-loading="is.loading && !is.initialised" :is-empty="!hospitals.length" empty-message="No hospitals added." v-on:tab="domain = $event">

        <div class="domain-title">{{ $constants.domainTitle[domain] }}</div>

        <app-table>
            <thead>
                <tr>
                    <th width="200">Hospital</th>
                    <th>Progression</th>
                    <th width="120" align="center">Completed</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in rows" :key="item.id">
                    <td>{{ item.hospital }}</td>
                    <td><app-progress :total="item.started" :value="item.completed" /></td>
                    <td align="center">{{ item.completed }} / {{ item.started }}</td>
                </tr>   
            </tbody>
        </app-table>

    </app-panel>

    <app-actions>

        <app-button text="Save as PDF" theme="grey" v-on:click.native="onExportClick('pdf')" />
        <app-button text="Download as .xls" theme="grey" v-on:click.native="onExportClick('xls')" />

    </app-actions>

</app-section>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

    mixins: [mixCollection],

    data: function() {
    
        return {
            api: 'dashboard/organisation',
            filter: {
                from: null,
                to: null
            },
            domainTabs: {
                domain1: 'Domain 1',
                domain2: 'Domain 2',
                domain3: 'Domain 3',
                domain4: 'Domain 4',
                domain5: 'Domain 5',
                domain6: 'Domain 6',
                total: 'Total',
            },
            domain: 'domain1',
            hospitals: []
        }
    
    },

    computed: {
    
        rows: function() {
        
            var rows = []

            this.$_.each(this.hospitals, function(hospital) {

                var completed = 0
                var started = 0

                this.$_.each(this.collection, function(item) {
                
                    if (item.hospital === hospital.id && (item.domain === this.domain || this.domain === 'total')) {
                    
                        completed += item.completed
                        started += item.started
                    
                    }
                
                }.bind(this))
            
                rows.push({
                    hospital: hospital.name,
                    completed: completed,
                    started: started
                })
            
            }.bind(this))

            return rows
        
        }

    },

    methods: {

        onExportClick: function(type) {
        
            this.$api.get(this.api, {
                from: this.filter.from,
                to: this.filter.to,
                export: type
            }).then(function(json) {
            
                window.location.href = json.url
                
            })

        },
    
        afterLoad: function(json) {
        
            this.hospitals = json.hospitals
        
        }
    
    }

}

</script>

<style scoped>

.domain-title {
    color: #212121;
    font-size: 14px;
    font-weight: 500;
    padding: 40px 40px 20px 40px;
}

</style>
